import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { fetchOptionGroups, clearOptionGroupsErrors, deleteOptionGroup } from '../../actions';
import ActionButtons from '../home/ActionButtons';
import Alert from '../home/Alert';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import DialogModal from '../home/DialogModal';

const propTypes = {
  dispatch: PropTypes.func,
  optiongroups: PropTypes.object,
  optiongroupDelete: PropTypes.bool,
};

class ShowOptionGroups extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      deleteId: '',
      alertOpen: false,
      alertMessage: '',
      delete: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.optiongroupsDelete && (this.state.delete || nextProps.optiongroups.delete)) {
      const optiongroups = nextProps.optiongroups;
      optiongroups.delete = false;
      this.setState({
        delete: false,
        alertOpen: true,
        alertMessage: 'Option Group deleted!',
        optiongroups,
      });
      this.handleClose();
    }
    if (nextProps.error) {
      this.setState({
        delete: false,
        alertOpen: true,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
      });
    }
  }
  handleOpen(id) {
    this.setState({
      open: true,
      deleteId: id,
    });
  }
  handleClose() {
    this.setState({
      open: false,
      deleteId: '',
    });
  }
  handleDelete() {
    this.setState({
      delete: true,
    });
    this.props.dispatch(deleteOptionGroup(this.state.deleteId));
    this.props.dispatch(fetchOptionGroups());
  }
  alertHandleClose() {
    this.setState({
      alertMessage: '',
      alertOpen: false,
    });
    this.props.dispatch(clearOptionGroupsErrors());
    this.props.dispatch(fetchOptionGroups());
  }
  renderRowsTable() {
    return this.props.optiongroups.results.map((optiongroup, i) =>
      <TableRow key={i}>
        <TableRowColumn key={i}>{optiongroup.name}</TableRowColumn>
        <TableRowColumn key={i}>
          <ActionButtons
            onDelete={() => this.handleOpen(optiongroup.id)}
            onEdit={`/optiongroups/${optiongroup.id}`}
            onView={`/optiongroups/view/${optiongroup.id}`}
            disableForOperators
          />
        </TableRowColumn>
      </TableRow>
    );
  }
  render() {
    const tableStyles = {
      stripedRows: true,
      displaySelectAll: false,
      adjustForCheckbox: false,
      selectable: false,
      displayRowCheckbox: false,
    };
    return (
      <div>
        <DialogModal
          dialogOpen={this.state.open}
          dialogHandleClose={this.handleClose}
          dialogHandleSubmit={() => this.handleDelete()}
          dialogTitle="Delete Option Group"
          dialogMessage="Do you really want to delete this option group?"
          dialogActionTitle="Delete"
        />
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <Table selectable={false}>
          <TableHeader
            displaySelectAll={tableStyles.displaySelectAll}
            adjustForCheckbox={tableStyles.adjustForCheckbox}
          >
            <TableRow
              selectable={tableStyles.selectable}
            >
              <TableHeaderColumn>Name</TableHeaderColumn>
              <TableHeaderColumn style={{ textAlign: 'center' }}>Actions</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody
            stripedRows={tableStyles.stripedRows}
            displayRowCheckbox={tableStyles.displayRowCheckbox}
          >
            {this.renderRowsTable()}
          </TableBody>
        </Table>
      </div>
    );
  }
}

ShowOptionGroups.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ShowOptionGroups.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    error: state.optiongroups.error,
    optiongroups: state.optiongroups,
    optiongroupsDelete: state.optiongroups.optiongroupsDelete,
  };
}

export default connect(mapStateToProps)(ShowOptionGroups);



// WEBPACK FOOTER //
// ./src/components/optiongroups/ShowOptionGroups.js